export default "__VITE_ASSET__CmJ6T5sp__"